export default __webpack_public_path__ + "assets/org-wide-scope.bf9177d13e.png";